module.exports = __webpack_public_path__ + "bg_panflet_daughter.c1b24f74.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/bg_panflet_daughter.png
// module id = Mgfa
// module chunks = 0